<div class="row">
    <div class="col-12 ">


        <div class="bg-light w-100 px-3 py-3 fondoColor">
            <div class="row">

                <div class="contenedor-imagenes d-none d-sm-inline">
                    <app-ui-poster [movie]="commentMovie"> </app-ui-poster>
                </div>

                <div class="col-12 d-sm-none contenedor-imagen-mobile">
                    <div class="contenedor-imagen-mobile">
                        <img width="100%" [src]="picture" alt="">
                    </div>
                </div>

                <div class="col pl-lg-0 tituloMasInfo">
                    <div class="row">
                        <div class="col-sm-8">
                            <a href={{movieLink}} class="tituloRef">{{commentMovie.title}}
                                ({{commentMovie.releaseYear}})</a>
                        </div>
                        <div class="col-4 d-none d-sm-inline">
                            <div class="fechaText">
                                {{commentDateFormated}}
                            </div>
                        </div>
                    </div>
                    <br>
                    <!-- RATING -->
                    <div class="ratings" *ngIf="this.comment.score > 0">
                        <div class="row" style="padding-left: 15px;">
                            <div *ngFor="let item of starsFull">
                                <i class="fas fa-star cm-tx-color-11"></i>
                            </div>
                            <div *ngFor="let item of starsHalf">
                                <i class="fas fa-star-half-alt cm-tx-color-11"></i>
                            </div>
                            <div *ngFor="let item of starsEmpty">
                                <i class="far fa-star cm-tx-color-11"></i>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row pb-4" *ngIf="withAuthor">
                        <div class="col-12">
                            <div class="author">
                                Comentado por:
                                <a href="" class="authorHref">
                                    {{comment.author.firstName}} {{comment.author.lastName}}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="commentContainter" *ngIf="comment.comment.length < maxCommentLenght">
                        <p class="comentario" [innerHTML]="comment.comment">
                        </p>
                    </div>

                    <div class="textButtons" *ngIf="comment.comment.length > maxCommentLenght">
                        <div *ngIf="!showMoreText">
                            <p class="elipsis-3 comentario" [innerHTML]="comment.comment">
                            </p>
                            <div class="col-12 px-0 buttonContain">
                                <a (click)="showMoreText = !showMoreText" class="showMore"> Ver más</a>
                            </div>
                        </div>
                        <div *ngIf="showMoreText">
                            <p [innerHTML]="comment.comment" class="comentario">
                            </p>
                            <div class="col-12 px-0 buttonContain">
                                <a (click)="showMoreText = !showMoreText" class="showMore"> Ver menos</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 d-sm-none">
                        <div class="fechaText">
                            {{commentDateFormated}}
                        </div>
                    </div>

                </div>
                <br>
            </div>
        </div>
    </div>
</div>